import { render, staticRenderFns } from "./CreateLeadVerticalStep4.vue?vue&type=template&id=b0777b1c&"
import script from "./CreateLeadVerticalStep4.vue?vue&type=script&lang=ts&"
export * from "./CreateLeadVerticalStep4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports